import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// shadcn's class-name composer, package-local so components carry no app
// imports. Apps keep their own cn (shadcn's utils alias) for app code.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
